import classNames from "classnames/bind";
import styles from "./FinanceExampleSidePanel.module.scss";
import { GetFinanceExampleSidePanelResponse } from "services/motorpoint/financeExampleSidePanel";
import UIIcon from "common/blocks/UIIcon";

const cx = classNames.bind(styles);

const FinanceExampleSidePanel = (financeExample: GetFinanceExampleSidePanelResponse) => {
    return (
        <div className={cx("financeExampleContentWrapper")}>
            <div className={cx("vehicleInfo")}>
                <span className={cx("vehicleTitle")}>{financeExample.VehicleTitle}</span>
                <span className={cx("vehicleDescription")}>
                    {financeExample.VehicleDescription}
                </span>
            </div>
            <div
                className={cx("description")}
                dangerouslySetInnerHTML={{
                    __html: financeExample.Description,
                }}
            />
            <div className={cx("divider")} />
            <div className={cx("data")}>
                <div className={cx("data-title")}>{financeExample.MonthlyPaymentTitle}</div>
                <div className={cx("data-text")}>{financeExample.MonthlyPaymentText}</div>
            </div>
            <div className={cx("data")}>
                <div className={cx("data-title")}>{financeExample.InterestRateTitle}</div>
                <div className={cx("data-text")}>{financeExample.InterestRateText}</div>
            </div>
            <div className={cx("data")}>
                <div className={cx("data-title")}>{financeExample.TotalAmountTitle}</div>
                <div className={cx("data-text")}>{financeExample.TotalAmountText}</div>
            </div>
            <div className={cx("data")}>
                <div className={cx("data-title")}>{financeExample.CostOfCreditTitle}</div>
                <div className={cx("data-text")}>{financeExample.CostOfCreditText}</div>
            </div>
            <div className={cx("data")}>
                <div className={cx("data-title")}>{financeExample.OptionalFinalPaymentTitle}</div>
                <div className={cx("data-text")}>{financeExample.OptionalFinalPaymentText}</div>
            </div>
            <div className={cx("data")}>
                <div className={cx("data-title")}>{financeExample.PurchaseFeeTitle}</div>
                <div className={cx("data-text")}>{financeExample.PurchaseFeeText}</div>
            </div>
            <div className={cx("data")}>
                <div className={cx("data-title")}>{financeExample.AnnualMileageTitle}</div>
                <div className={cx("data-text")}>{financeExample.AnnualMileageText}</div>
            </div>
            <div className={cx("divider")} />
            <div className={cx("disclaimer")}>
                <UIIcon svgProps={{ className: cx("icon") }} icon="Info" />
                <div
                    className={cx("disclaimerText")}
                    dangerouslySetInnerHTML={{ __html: financeExample.LegalDisclaimer }}
                />
            </div>
        </div>
    );
};

export default FinanceExampleSidePanel;
